import {initTopBottom} from "../modulos/topbottom/topbottom";
import analisisMasVistos from "../modulos/analisisMasVistos/analisisMasVistos";
import {dispatchEvent} from "../utils/eventDispatch";
import './css/courseDetailPage.scss';
import Streaming from "../streaming/streaming";

const courseDetailLogic = () => {
    const courseDetail = document.querySelector('#detalleCourse');
    const flatPicker = courseDetail.dataset.datepicker;

    if (flatPicker) {
        Promise.all([
            import('flatpickr'),
            import('flatpickr/dist/l10n/es')
        ])
            .then(ok => {
                dispatchEvent('CourseDetailLoaded');
            })
    } else {
        dispatchEvent('CourseDetailLoaded');
    }
}

export const courseDetailPage = () => {
    //Inicializa los módulos de top/flops
    initTopBottom(Streaming);

    //Módulo de análisis más vistos
    analisisMasVistos();

    courseDetailLogic();
}
